import React, { useMemo, useState } from "react";
import { Container, Accordion, AccordionBody, AccordionHeader, AccordionItem } from "reactstrap";
import { FiSearch } from "react-icons/fi";
import { Bell } from "assets";
import "./bantuan.scss";

/**
 * KONTEN SEMENTARA — belum final.
 *
 * Pertanyaan di bawah disusun dari alur yang memang ada di aplikasi, dan
 * jawabannya hanya diisi untuk hal yang bisa dipastikan dari perilaku aplikasi
 * itu sendiri (mis. kapan anggota menjadi Member, format berkas impor).
 *
 * Untuk hal yang bergantung pada kebijakan operasional — lama proses aktivasi,
 * jadwal pembayaran royalti, alur persetujuan transaksi — `answer` sengaja
 * dibiarkan `null`. Halaman akan menampilkannya sebagai "sedang disiapkan"
 * alih-alih menebak jawaban yang belum tentu benar. Jangan mengisi bagian itu
 * tanpa konfirmasi dari tim operasional.
 *
 * Saat konten resmi sudah ada, ganti array ini — atau pindahkan ke API dan
 * ambil lewat `src/services/get.js` mengikuti pola endpoint lain.
 */
const FAQ_CATEGORIES = [
  {
    id: "akun",
    title: "Akun & Profil",
    items: [
      {
        id: "akun-telepon",
        question: "Kenapa saya diminta mengisi nomor telepon setelah login?",
        answer:
          "Nomor telepon wajib dilengkapi sebelum bisa memakai menu lain. Selama nomor belum diisi, formulir pengisiannya akan terus muncul setiap kali membuka aplikasi.",
      },
      {
        id: "akun-ubah-profil",
        question: "Bagaimana cara mengubah data profil saya?",
        answer:
          "Buka menu Profile di sidebar. Data umum, data bank, dan penggantian kata sandi ada di halaman tersebut.",
      },
      {
        id: "akun-format-tanggal",
        question: "Format tanggal apa yang dipakai di aplikasi ini?",
        answer:
          "Seluruh tanggal memakai format DD-MM-YYYY, misalnya 15-01-1990. Format ini berlaku sama di tampilan maupun saat mengisi formulir.",
      },
    ],
  },
  {
    id: "keanggotaan",
    title: "Keanggotaan",
    items: [
      {
        id: "anggota-member",
        question: "Apa bedanya status Member dan Non-Member?",
        answer:
          "Anggota berstatus Member setelah admin melakukan aktivasi. Sebelum diaktivasi, anggota masih berstatus Non-Member dan sebagian menu belum bisa diakses.",
      },
      {
        id: "anggota-draft-kontrak",
        question: "Kenapa saya selalu diarahkan ke halaman draft kontrak?",
        answer:
          "Halaman itu muncul selama akun belum diaktivasi admin. Setelah aktivasi selesai, aplikasi otomatis membuka seluruh menu dan halaman tersebut tidak muncul lagi.",
      },
      {
        id: "anggota-pencipta-ahli-waris",
        question: "Apa beda mendaftar sebagai Songwriter dan Ahli Waris?",
        answer:
          "Keduanya memakai formulir yang berbeda. Pendaftaran Ahli Waris meminta data Songwriter yang diwakili beserta dokumen penunjukan ahli waris, sedangkan pendaftaran Songwriter hanya meminta data Songwriter itu sendiri.",
      },
      {
        id: "anggota-lama-aktivasi",
        question: "Berapa lama proses aktivasi anggota?",
        answer: null,
      },
    ],
  },
  {
    id: "katalog",
    title: "Katalog Lagu",
    items: [
      {
        id: "katalog-tambah",
        question: "Bagaimana cara menambahkan lagu ke katalog?",
        answer:
          "Buka menu Katalog Lagu, lalu gunakan tombol Create di kanan atas tabel untuk mengisi data lagu satu per satu.",
      },
      {
        id: "katalog-impor",
        question: "Bisakah menambahkan banyak lagu sekaligus?",
        answer:
          "Bisa, lewat tombol Import. Unduh dulu templat yang disediakan di dalam jendela impor, isi datanya, lalu unggah kembali berkas tersebut.",
      },
      {
        id: "katalog-format-berkas",
        question: "Berkas apa yang bisa diunggah saat impor?",
        answer:
          "Berkas Excel dengan ekstensi .xlsx atau .xls. Sebelum diunggah, aplikasi menampilkan pratinjau beberapa baris pertama supaya isinya bisa diperiksa dulu.",
      },
    ],
  },
  {
    id: "transaksi",
    title: "Transaksi & Lisensi",
    items: [
      {
        id: "transaksi-jenis",
        question: "Apa isi List of Request, List Transaksi, dan Riwayat Transaksi?",
        answer:
          "Ketiganya adalah penyaring untuk daftar yang sama. Pilih salah satu lewat dropdown jenis transaksi di atas tabel untuk menampilkan kelompok transaksi yang diinginkan.",
      },
      {
        id: "transaksi-status",
        question: "Bagaimana alur perubahan status sebuah transaksi?",
        answer: null,
      },
      {
        id: "transaksi-dokumen",
        question: "Bagaimana cara mengirim dokumen transaksi ke klien?",
        answer: null,
      },
    ],
  },
  {
    id: "laporan",
    title: "Laporan & Pembayaran",
    items: [
      {
        id: "laporan-pendapatan",
        question: "Di mana saya bisa melihat laporan pendapatan?",
        answer:
          "Menu Laporan di sidebar berisi dua halaman: Pendapatan untuk rekapitulasi pemasukan, dan Distribusi untuk rincian penyalurannya.",
      },
      {
        id: "laporan-rekening",
        question: "Bagaimana cara menambahkan rekening bank?",
        answer:
          "Buka Profile, lalu bagian data bank. Nama bank, nama pemilik rekening, dan nomor rekening diisi di sana.",
      },
      {
        id: "laporan-jadwal-royalti",
        question: "Kapan royalti dibayarkan?",
        answer: null,
      },
    ],
  },
];

/**
 * Kontak bantuan.
 *
 * SEMENTARA — belum ada kanal dukungan resmi yang tercatat di aplikasi.
 * Isi nilai di bawah dengan alamat email / nomor WhatsApp yang benar sebelum
 * halaman ini dipakai pengguna. Jangan diisi alamat karangan: pengguna akan
 * benar-benar mencoba menghubunginya.
 */
const SUPPORT_CONTACT = null;

const ANSWER_PENDING_TEXT =
  "Jawaban untuk pertanyaan ini sedang disiapkan dan akan segera dilengkapi.";

const Bantuan = () => {
  const [keyword, setKeyword] = useState("");
  const [openId, setOpenId] = useState("");

  // Accordion reactstrap mengirim balik targetId yang diklik. Mengklik item
  // yang sedang terbuka akan menutupnya kembali.
  const toggleItem = (id) => {
    setOpenId((prevId) => (prevId === id ? "" : id));
  };

  // Pencarian dilakukan di sisi klien karena datanya masih statis. Begitu FAQ
  // pindah ke API, bagian ini yang diganti pemanggilan endpoint pencarian.
  const filteredCategories = useMemo(() => {
    const query = keyword.trim().toLowerCase();
    if (!query) return FAQ_CATEGORIES;

    return FAQ_CATEGORIES.map((category) => ({
      ...category,
      items: category.items.filter(
        (item) =>
          item.question.toLowerCase().includes(query) ||
          (item.answer || "").toLowerCase().includes(query)
      ),
    })).filter((category) => category.items.length > 0);
  }, [keyword]);

  const hasResult = filteredCategories.length > 0;

  return (
    <Container fluid className="content-pencipta">
      <div className="header-content">
        <div className="pencipta-header">
          <h1>Bantuan</h1>
        </div>
        <div className="icon-wrapper">
          <Bell />
        </div>
      </div>

      <div className="bantuan-notice">
        Halaman ini masih dalam penyusunan. Sebagian jawaban belum tersedia dan
        akan dilengkapi secara bertahap.
      </div>

      <div className="bantuan-search">
        <FiSearch className="bantuan-search-icon" />
        <input
          type="text"
          className="bantuan-search-input"
          placeholder="Cari pertanyaan, misalnya: impor lagu"
          value={keyword}
          onChange={(event) => setKeyword(event.target.value)}
        />
      </div>

      {hasResult ? (
        filteredCategories.map((category) => (
          <section className="bantuan-category" key={category.id}>
            <h2 className="bantuan-category-title">{category.title}</h2>

            <Accordion flush open={openId} toggle={toggleItem}>
              {category.items.map((item) => (
                <AccordionItem key={item.id}>
                  <AccordionHeader targetId={item.id}>
                    {item.question}
                  </AccordionHeader>
                  <AccordionBody accordionId={item.id}>
                    {item.answer ? (
                      item.answer
                    ) : (
                      <span className="bantuan-answer-pending">
                        {ANSWER_PENDING_TEXT}
                      </span>
                    )}
                  </AccordionBody>
                </AccordionItem>
              ))}
            </Accordion>
          </section>
        ))
      ) : (
        <div className="bantuan-empty">
          Tidak ada pertanyaan yang cocok dengan "{keyword}".
        </div>
      )}

      <div className="bantuan-contact">
        <h3 className="bantuan-contact-title">Masih butuh bantuan?</h3>
        {SUPPORT_CONTACT ? (
          <p className="bantuan-contact-text">
            Hubungi kami di <strong>{SUPPORT_CONTACT}</strong>.
          </p>
        ) : (
          <p className="bantuan-contact-text">
            Kanal bantuan resmi sedang disiapkan. Untuk sementara, sampaikan
            kendala kamu lewat admin yang biasa menangani akunmu.
          </p>
        )}
      </div>
    </Container>
  );
};

export default Bantuan;
